module.exports = __webpack_public_path__ + "videos/homepage.702482c.webm";